import React, { useRef } from 'react'
import type { InterviewChoiceResource } from '@entities/api/Interview'
import { useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  itemName: string | null
  choices: InterviewChoiceResource[]
  required: boolean
}

const Multiple: React.FC<Props> = ({ prefix, itemName, choices, required }) => {
  const myRef = useRef<HTMLDivElement>(null)
  const { register, watch, setValue } = useFormContext()
  const errorPrefix = `${itemName ? `${itemName}について、` : ''}`

  const inputName = `${prefix}.value`
  const value = watch(inputName)
  const selected = value ? value.split('|') : []

  const handleChangeCheckbox = () => {
    if (!myRef.current) return
    setValue(
      inputName,
      Array.from<HTMLInputElement>(myRef.current.querySelectorAll('input[type=checkbox]:checked'))
        .map((element) => element.value)
        .join('|')
    )
  }

  return (
    <div ref={myRef} className="row pb-4">
      <div className="col input-group">
        <input
          ref={register({ required: required && `${errorPrefix}1つ以上選択してください` })}
          type="hidden"
          name={inputName}
        />
        {choices.map((choice) => (
          <div key={choice.id} className="form-check p-0 w-100">
            <label className="border-0 zm-checkbox m-0 mb-2 w-100">
              <input
                type="checkbox"
                className="d-none"
                value={choice.body}
                checked={selected.indexOf(choice.body) >= 0}
                onChange={handleChangeCheckbox}
              />
              <div className="zm-checkmark zm-checkmark-t2" />
              {choice.body}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Multiple
